// @flow
import { createSelector } from "reselect";

import { type State } from "../";
import {
  type ConfiguracaoGlobalRelatorio,
  MODO_APP_SERIES,
  ID_PERIODO_DATAS_ESPECIFICAS_MODO_SERIES,
  FORMA_VISUALIZACAO_SERIES_POR_ATIVOS,
  FORMA_VISUALIZACAO_SERIES_POR_DATAS,
} from "../../model";
import {
  getEdicaoMedidaGlobal,
  getDataInicialFormatadaBanco,
  getDataFinalFormatadaBanco,
} from "./edicaoMedidaSelectors";
import { getDataBaseFormatadaBanco } from "./dataBaseSelectors";
import { getFuncaoQtLink } from "./funcaoQtLinkSelectors";
import { getNomeArquivoEmCache } from "./arquivosMedidasSelectors";
import { getModoApp, getTipoDataBaseSelecionada } from "./comum";

export const modoVisualizacaoSeries = (state: State): * =>
  state.configuracaoSeries.modoVisualizacao;

export const modoVisualizacaoStringSeries = (state: State): * => {
  switch (state.configuracaoSeries.modoVisualizacao) {
    case FORMA_VISUALIZACAO_SERIES_POR_ATIVOS:
      return "POR_ATIVOS";
    case FORMA_VISUALIZACAO_SERIES_POR_DATAS:
      return "POR_DATAS";
    default:
      return null;
  }
};

export const identificadoresSeries = (state: State): * =>
  state.configuracaoSeries.identificadores;

export const exibirDatasSemNegociacaoSeries = (state: State): * =>
  state.configuracaoSeries.exibirDatasSemNegociacao;

export const getConfiguracaoGlobalRelatorio: State => ConfiguracaoGlobalRelatorio = createSelector(
  getModoApp,
  getEdicaoMedidaGlobal,
  exibirDatasSemNegociacaoSeries,
  identificadoresSeries,
  getDataBaseFormatadaBanco,
  getTipoDataBaseSelecionada,
  getDataInicialFormatadaBanco,
  getDataFinalFormatadaBanco,
  getFuncaoQtLink,
  getNomeArquivoEmCache,
  (
    modoApp,
    edicaoMedidaGlobal,
    exibirDatasSemNegociacao,
    identificadoresAtivos,
    dataBase,
    tipoDataBase,
    dataInicial,
    dataFinal,
    yamlConfiguracao,
    nomeGrupoMedidasAberto
  ) => {
    const periodo = edicaoMedidaGlobal.periodos[0];
    const isDatasEspecificasModoSeries: boolean =
      periodo === ID_PERIODO_DATAS_ESPECIFICAS_MODO_SERIES;

    if (modoApp === MODO_APP_SERIES) {
      return {
        dataBase,
        tipoDataBase,
        periodicidade: edicaoMedidaGlobal.periodicidade,
        ajusteDias: edicaoMedidaGlobal.ajusteDias,
        periodo: periodo,
        dataInicial: isDatasEspecificasModoSeries ? dataInicial : null,
        dataFinal: isDatasEspecificasModoSeries ? dataFinal : null,
        exibirDatasSemNegociacao,
        identificadoresAtivos,
        yamlConfiguracao,
        nomeGrupoMedidasAberto,
      };
    } else {
      return {
        dataBase,
        tipoDataBase,
      };
    }
  }
);
